/**
 *
 *
 * Author:   shann
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2021/3/24      1.0     First version
 *
 * Copyright  2021/3/24 , all rights reserved. Essa.cn
 * */
import underscore from "underscore";
import md5 from "md5";

export function isArray(target) {
    return Array.isArray(target);
}

export function isObject(obj) {
    return Object.prototype.toString.call(obj) === "[object Object]";
}

export function isEmpty(value) {
    if (value === undefined || value === null) {
        return true;
    }
    if (isObject(value)) {
        return Object.keys(value).length === 0;
    }
    return false;
}

export function getColumns(objects, columns) {
    if (isEmpty(objects)) {
        return;
    }
    return objects.map(function (object) {
        let obj = {};
        for (const key in columns) {
            let name = isArray(columns) ? columns[key] : key;
            obj[name] = object[columns[key]];
        }
        return obj;
    });
}

class Helper {
    static _primary = null;

    static get primary() {
        return Helper._primary || (Helper._primary = new Helper());
    }

    md5 = md5;

    /**
     * 是否数组
     * @param  {...any} rest
     * @returns
     */
    isString(value) {
        return underscore.isString(value);
    }

    /**
     * 是否为空
     * @param {boolean} object
     * @returns
     */
    isEmpty(any) {
        if (underscore.isNull(any)) {
            return true;
        }
        if (underscore.isString(any) && any.length === 0) {
            return true;
        }
        if (parseInt(any) === 0) {
            return true;
        }
        if (underscore.isNumber(any) && any !== 0) {
            return false;
        }
        return underscore.isEmpty(any);
    }

    /**
     * 是否数组
     * @param boolean value
     * @returns
     */
    isArray(value) {
        return Array.isArray(value);
    }

    /**
     * 对象交集
     * @returns Object
     */
    intersection() {
        let objects = arguments;
        for (let i = 1; i < objects.length; i++) {
            for (const key in objects[0]) {
                if (objects[0].hasOwnProperty.call(objects[0], key)) {
                    objects[0][key] = objects[i][key];
                }
            }
        }
        return objects[0];
    }

    overwrite() {
        let objects = arguments;
        for (let i = 1; i < objects.length; i++) {
            for (const key in objects[0]) {
                if (
                    objects[0].hasOwnProperty.call(objects[0], key) &&
                    objects[i][key] !== null
                ) {
                    objects[0][key] = objects[i][key];
                }
            }
        }
        return objects[0];
    }
}

Helper.md5 = md5;

export default Helper.primary;
